import { FormattedMessage } from "react-intl";
import type { intlFormatPropTypes } from "react-intl";

import useHostHubUpcomingBookings from "../../hooks/useHostHubUpcomingBookings";
import type {
  HostHubUpcomingBooking,
  HostHubUpcomingBookingGroups,
} from "../../types/model/upcoming-booking";
import HostHubUpcomingPanelBookingGroup from "./HostHubUpcomingPanelBookingGroup";

type HostHubUpcomingPanelBookingsProps = {
  intl: intlFormatPropTypes;
};

const HostHubUpcomingPanelBookings = ({
  intl,
}: HostHubUpcomingPanelBookingsProps) => {
  const { groups } = useHostHubUpcomingBookings();

  const groupSections: Array<{
    bookings: HostHubUpcomingBooking[];
    key: keyof HostHubUpcomingBookingGroups;
    label: JSX.Element;
  }> = [
    {
      bookings: groups.today,
      key: "today",
      label: (
        <FormattedMessage
          defaultMessage="Today"
          id="host_hub.upcoming.today"
        />
      ),
    },
    {
      bookings: groups.thisWeek,
      key: "thisWeek",
      label: (
        <FormattedMessage
          defaultMessage="This week"
          id="host_hub.upcoming.this_week"
        />
      ),
    },
    {
      bookings: groups.thisMonth,
      key: "thisMonth",
      label: (
        <FormattedMessage
          defaultMessage="This month"
          id="host_hub.upcoming.this_month"
        />
      ),
    },
  ];

  const upcomingBookingGroups = groupSections
    .filter(({ bookings }) => bookings.length > 0)
    .map(({ bookings, key, label }) => (
      <HostHubUpcomingPanelBookingGroup
        bookings={bookings}
        intl={intl}
        key={key}
        label={label}
      />
    ));

  return (
    <div className="tw-flex tw-flex-col tw-gap-[16px]">{upcomingBookingGroups}</div>
  );
};

export default HostHubUpcomingPanelBookings;
